import { useEffect } from 'react';
import { toast } from 'sonner';
import { DEMO_VIEW_ONLY } from '@altsui/shared';
import { onRefusalCode } from '@/lib/api/apiRequestError';

/** Any request refused because this is a demo shows one notice, whichever screen made it; repeats replace it. */
export function DemoViewNotice(): null {
  useEffect(() => onRefusalCode(DEMO_VIEW_ONLY.code, () => {
    toast(DEMO_VIEW_ONLY.message, { id: DEMO_VIEW_ONLY.code });
  }), []);
  return null;
}
